import * as React from "react"
import { cn } from "../../lib/utils"

const Separator = React.forwardRef(
  ({ className, orientation = "horizontal", decorative = true, ...props }, ref) => (
    <div
      ref={ref}
      role={decorative ? "none" : "separator"}
      aria-orientation={orientation}
      className={cn("ui-separator", orientation === "vertical" && "ui-separator-vertical", className)}
      {...props}
    />
  )
)

Separator.displayName = "Separator"

export { Separator }
